import {
    Box,
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    Typography,
    useMediaQuery,
} from '@mui/material';

import React from 'react';

import EqualizerIcon from '@mui/icons-material/Equalizer';

import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';

import FileDownloadIcon from '@mui/icons-material/FileDownload';

import { useGetGuestUserStatsQuery } from '../../../../../app/Slices/SevenDayApiSlice';

import { CustomButton } from '../../../../../layout/styledcomponents/CustomButton';

import {
    formatProfileBreakdown,
    formatStatusBreakdown,
    GuestUserCategoryBreakdown,
    guestUserBreakdownToPoints,
    guestUserCategoryLabel,
} from '../../guestUserStatsFormat';

import { openDashboardReportExportMenu } from '../../dashboardReportTableConfig';

import ReportTableTabs, { ReportTableTab } from '../../ReportTableTabs';

import GuestUsersReportGraph from './GuestUsersReportGraph';

import GuestUsersBreakdownList from './GuestUsersBreakdownList';

import GuestUsersReportList from './GuestUsersReportList';

const breakdownOptions = [
    { value: GuestUserCategoryBreakdown.Status, label: 'Status' },

    { value: GuestUserCategoryBreakdown.Profile, label: 'Profile' },
];

export default function GuestUsersComponentPage() {
    const isMobile = useMediaQuery('(max-width: 770px)');

    const [graphView, setGraphView] = React.useState(true);

    const [tableTab, setTableTab] = React.useState<ReportTableTab>('summary');

    const [categoryBreakdown, setCategoryBreakdown] =
        React.useState<GuestUserCategoryBreakdown>(
            GuestUserCategoryBreakdown.Status,
        );

    const { data } = useGetGuestUserStatsQuery();

    const total = data?.totalGuestUsers ?? 0;

    const categoryLabel = guestUserCategoryLabel(categoryBreakdown);

    const points = guestUserBreakdownToPoints(data, categoryBreakdown);

    const breakdownSummary =
        categoryBreakdown === GuestUserCategoryBreakdown.Status
            ? formatStatusBreakdown(data)
            : formatProfileBreakdown(data);

    return (
        <Grid sx={{ mt: 1 }}>
            <Grid
                sx={{
                    display: 'flex',

                    flexDirection: isMobile ? 'column' : 'row',

                    justifyContent: 'space-between',

                    gap: 1.5,

                    mb: 2,
                }}
            >
                <FormControl size='small' sx={{ minWidth: 170 }}>
                    <InputLabel id='guest-user-breakdown-label'>
                        Breakdown
                    </InputLabel>

                    <Select
                        labelId='guest-user-breakdown-label'
                        value={categoryBreakdown}
                        label='Breakdown'
                        onChange={(event) =>
                            setCategoryBreakdown(
                                event.target
                                    .value as GuestUserCategoryBreakdown,
                            )
                        }
                    >
                        {breakdownOptions.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

                <Box
                    sx={{
                        display: 'flex',

                        alignItems: 'center',

                        gap: 1,

                        flexWrap: 'wrap',
                    }}
                >
                    {graphView ? (
                        <CustomButton
                            disableRipple
                            variant='outlined'
                            color='primary'
                            onClick={() => setGraphView(false)}
                        >
                            <FormatListBulletedIcon fontSize='small' />
                        </CustomButton>
                    ) : (
                        <>
                            <CustomButton
                                disableRipple
                                variant='outlined'
                                color='primary'
                                onClick={() => setGraphView(true)}
                            >
                                <EqualizerIcon fontSize='small' />
                            </CustomButton>

                            {tableTab === 'items' ? (
                                <CustomButton
                                    disableRipple
                                    variant='contained'
                                    color='neutral'
                                    onClick={openDashboardReportExportMenu}
                                >
                                    <FileDownloadIcon fontSize='small' />
                                </CustomButton>
                            ) : null}
                        </>
                    )}
                </Box>
            </Grid>

            <Typography variant='h5' sx={{ mb: 1 }}>
                {total.toLocaleString()} total guest users
            </Typography>

            <Typography variant='body2' sx={{ mb: 2 }}>
                {breakdownSummary}
            </Typography>

            <Grid>
                {graphView ? (
                    <GuestUsersReportGraph
                        data={data}
                        breakdown={categoryBreakdown}
                    />
                ) : (
                    <ReportTableTabs
                        summaryLabel={`By ${categoryLabel}`}
                        itemsLabel='Individual Users'
                        onTabChange={setTableTab}
                        summaryContent={
                            <GuestUsersBreakdownList
                                points={points}
                                categoryLabel={categoryLabel}
                            />
                        }
                        itemsContent={
                            <GuestUsersReportList data={data?.users} />
                        }
                    />
                )}
            </Grid>
        </Grid>
    );
}
